module.exports = __webpack_public_path__ + "static/media/PowerlineIcon.5bd6365b.svg";